/*
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { LoadingService } from '@loader/spinner';
import { AuthActions } from '../redux/auth.actions';
import environment from '@environments/environment';

@Component({
  template: `<div></div>`,
  standalone: false,
})
export class OktaCallbackComponent implements OnInit, OnDestroy {
  private readonly _store = inject(Store);
  private readonly _loading = inject(LoadingService);

  error?: string;
  loadingSubscription?: Subscription;

  async ngOnInit(): Promise<void> {
    console.log('OktaCallbackComponent ngOnInit');
    this._loading.showLoading();

    const url = new URL(window.location.href);

    if (!url.searchParams.get('code') || !url.searchParams.get('state')) {
      this._loading.hideLoading();
      window.location.href = environment.clinsphereUrl;
      return;
    }

    // Dispatch the action to handle login redirect
    this._store.dispatch(AuthActions.handleLoginRedirect());
  }

  ngOnDestroy(): void {
    this._loading.hideLoading();
  }
}
